class ProductViewed extends HTMLElement {
  connectedCallback() {
    const handle = this.getAttribute('handle');
    if (handle) {
      this.addToViewedProducts(handle);
    }
  }

  /**
   * @description Adds a product handle to the recently viewed products list in localStorage.
   * @param {string} handle - The product handle to add.
   */
  addToViewedProducts(handle) {
    try {
      // Get existing viewed products from localStorage
      const viewedProducts = JSON.parse(localStorage.getItem('viewedProducts') || '[]');

      // Remove the handle if it already exists (to move it to the front)
      const filteredProducts = viewedProducts.filter((product) => product !== handle);

      // Add the current handle to the beginning of the array
      filteredProducts.unshift(handle);

      // Keep only the last 10 viewed products to prevent localStorage from growing too large
      const limitedProducts = filteredProducts.slice(0, 10);

      // Save back to localStorage
      localStorage.setItem('viewedProducts', JSON.stringify(limitedProducts));
    } catch (error) {
      console.warn('Failed to save product to recently viewed:', error);
    }
  }
}

customElements.define('product-viewed', ProductViewed);
